export default "__VITE_ASSET__DUN1HgtS__"